import { apiUrl } from '../runtime'

// Browser replacement for the server-only `@/app/actions/account` in the sidebar widget build.
// The Sidebar only calls updatePreferences (pin/reorder nav, pin markets), which we persist
// via core's REST endpoint with the shared session cookie — mirroring the server action's
// PATCH /api/users/me/preferences exactly.
export async function updatePreferences(data: {
  pinned_nav?: string[]
  favourite_leaderboards?: string[]
  pinned_markets?: { type: 'market' | 'event'; id: number }[]
}): Promise<{ error?: string }> {
  try {
    const res = await fetch(apiUrl('/api/users/me/preferences'), {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    if (!res.ok) {
      // Surface the backend's `detail` like the server action does — far more actionable when
      // the widget runs cross-origin and failures are often CORS/auth-related. 401 (no shared
      // session cookie reached core) gets a clearer default than a generic message.
      const body = (await res.json().catch(() => ({}))) as { detail?: string }
      const fallback = res.status === 401 ? 'Not authenticated' : 'Failed to update preferences'
      return { error: body.detail ?? fallback }
    }
    return {}
  } catch {
    return { error: 'Failed to update preferences' }
  }
}
